let metricVals = [
  { text: 'Performance', value: 'Performance', key: 'Performance' },
  { text: 'Accessibility', value: 'Accessibility', key: 'Accessibility' },
  { text: 'BestPractices', value: 'BestPractices', key: 'BestPractices' },
  { text: 'SEO', value: 'SEO', key: 'SEO' },
  { text: 'PageWeight(MB)', value: 'PageWeight', key: 'PageWeight' },
  { text: 'JsExecution(Sec)', value: 'JavaScriptExecutionTime', key: 'JavaScriptExecutionTime' }
]

export default metricVals;